import { FilterSection } from './FilterSection';

interface SearchFilterProps {
    searchTerm: string;
    onSearchChange: (term: string) => void;
}

export function SearchFilter({ searchTerm, onSearchChange }: SearchFilterProps) {
    return (
        <FilterSection title="Search by Name or Description" defaultOpen={true}>
            <input
                type="text"
                placeholder="Enter keywords..."
                className="w-full px-3 py-2 text-sm bg-white border border-gray-200 rounded-md focus:border-indigo-500 focus:outline-none placeholder-gray-400"
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
            />
        </FilterSection>
    );
} 